/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import PerfectScrollbar from "react-perfect-scrollbar";

class EventComment extends Component {
  state = {
    comment: '',
    gotoPage: 1,
    pageCount: 0,
    con: 0,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    const { eventIdx } = this.props.childProps;
    //console.log(eventIdx)
    if (eventIdx === '' || eventIdx === null || eventIdx === 0) {
    } else {
      this._getData(eventIdx, 1);
    }
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async (idx, gotoPage) => {
    const result = await this._getDataApi(idx, gotoPage);
    const intReturn = result.data[0].intReturn;
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;

    const commentList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          commentList,
          gotoPage: gotoPage,
          con,
          pageCount,
        });
      }
    } else {
      this.setState({
        commentList: null,
      });
    }
  };

  _getDataApi = (idx, gotoPage) => {
    const { apiUrl } = this.props;
    //const { gotoPage } = this.state
    return axios
      .post(apiUrl + '/eventCommentListPaging', {
        params: {
          idx: idx,
          gotoPage: gotoPage,
          pageSize: 20,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _renderItem = () => {
    const { commentList } = this.state;
    const { loginId } = this.props;

    const list = commentList.map((item, index) => {
      return (
        <dl key={index}>
          <dt>
            <span>
              <img src={item.charac_img} />
            </span>
          </dt>
          <dd>
            <h2>
              {item.nicName} <em>{item.regDate}</em>{' '}
              {item.userid === loginId ? (
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => this._onDel(item.serial)}
                >
                  내글
                </span>
              ) : null}
            </h2>
            <p>{item.comment}</p>
          </dd>
        </dl>
      );
    });

    return list;
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _onChange = (e) => {
    this.setState({
      comment: e.target.value,
    });
  };
  _onWrite = async () => {
    const { loginId } = this.props;
    const { comment } = this.state;
    const { eventIdx } = this.props.childProps;

    if (loginId === '' || loginId === undefined || loginId === null) {
      toast.warn('로그인 후 이용해 주세요');
    } else {
      if (comment === '' || comment === null || comment === undefined) {
        toast.warn('의견을 입력해 주세요.');
      } else {
        const result = await this._onWriteApi(eventIdx);
        if (result) {
          const intReturn = result.data[0].intReturn;

          if (intReturn === 0) {
            toast.success('정상적으로 댓글이 입력되었습니다.');
            this._getData(eventIdx, 1);
            this.setState({
              comment: '',
            });
          } else {
            toast.error('등록중 오류가 발생했습니다.');
          }
        }
      }
    }
  };
  _onWriteApi = (idx) => {
    const { apiUrl, loginId, history } = this.props;
    const { comment } = this.state;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/eventCommentWrite',
        {
          params: {
            userid: loginId,
            idx: idx,
            comment: comment,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken('add', 0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (gubun, serial) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 'add') {
        this._onWrite();
      } else if (gubun === 'del') {
        this._onDel(serial);
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };

  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onDel = async (serial) => {
    const { loginId } = this.props;
    const { eventIdx } = this.props.childProps;

    if (loginId === '' || loginId === undefined || loginId === null) {
      toast.warn('로그인 후 이용해 주세요');
    } else {
      if (serial === '' || serial === null || serial === undefined) {
        toast.warn('파라메터가 누락되었습니다.');
      } else {
        const result = await this._onDelApi(serial);
        if (result) {
          const intReturn = result.data[0].intReturn;

          if (intReturn === 0) {
            toast.success('정상적으로 삭제 되었습니다.');

            setTimeout(() => {
              this._getData(eventIdx, 1);
            }, 400);
          } else {
            toast.error('삭제중 오류가 발생했습니다.');
          }
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _onDelApi = (serial) => {
    const { apiUrl, loginId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    // const { comment } = this.state;

    return axios
      .post(
        apiUrl + '/eventCommentDel',
        {
          params: {
            userid: loginId,
            serial: serial,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken('del', serial);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _renderPage = () => {
    const { pageCount, gotoPage } = this.state;
    const { eventIdx } = this.props.childProps;
    const pageNumbers = [];
    let blockPage = ((gotoPage - 1) / 10) * 10 + 1;
    let i = 0;
    ////console.log(blockPage, pageCount)
    do {
      pageNumbers.push(i);
      blockPage = blockPage + 1;
      i = i + 1;
    } while (i < 10 && i < pageCount);
    ////console.log(pageNumbers)
    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={() => this._getData(eventIdx, num + 1)}
          className={gotoPage === num + 1 ? 'on' : null}
        >
          {num + 1}
        </span>
      );
    });

    return list;
  };
  _onPrev = () => {
    const { gotoPage } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn('페이지의 처음입니다.');
    } else {
      this._getData(gotoPage - 1);
    }
  };
  _onNext = () => {
    const { pageCount, gotoPage } = this.state;

    if (gotoPage + 1 >= pageCount) {
      toast.warn('페이지의 마지막입니다.');
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1);
    }
  };
  render() {
    const { commentList, comment, pageCount, con } = this.state;
    return (
      <div className="pop_padding_70">
        <div className="detil_group4" style={{ marginTop: -150 }}>
          <h1>
            댓글<span>.총 {commentList ? this._CommaFormatted(con) : 0}개</span>
          </h1>
          <div className="libyu_textarea">
            <p className="">
              <textarea
                name=""
                cols=""
                rows=""
                className="common_input libyu_input"
                placeholder="의견을 남겨주세요"
                value={comment}
                onChange={this._onChange}
              ></textarea>
            </p>
            <span style={{ cursor: 'pointer' }} onClick={this._onWrite}>
              <em>등록</em>
            </span>
          </div>

          <div className="libyu_group">
            <div className="libyu_list">
              {commentList ? this._renderItem() : null}
            </div>
            <div className="page_no">
              <span style={{ cursor: 'pointer' }} onClick={this._onPrev}>
                이전
              </span>
              {pageCount > 0 ? (
                this._renderPage()
              ) : (
                <span style={{ cursor: 'pointer' }} className="on">
                  1
                </span>
              )}
              <span style={{ cursor: 'pointer' }} onClick={this._onNext}>
                다음
              </span>
            </div>
            {/*
                        <div className="page_no">
                            <span>이전</span>
                            <span className="on">1</span>
                            <span>2</span>
                            <span>3</span>
                            <span>4</span>
                            <span>5</span>
                            <span>6</span>
                            <span>7</span>
                            <span>8</span>
                            <span>9</span>
                            <span>10</span>
                            <span>다음</span>
                        </div>
                        */}
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>
    );
  }
}

export default shopContext(withRouter(EventComment));
